import type { Block } from "@unruly-global/api-types";

/**
 * Find the UID of a block whose title matches `title`, searching forward
 * from the block with `targetUid` and stopping at the next `sec-type-*`
 * divider or end of blocks.
 */
export function findSubEntryUid(
  title: string,
  targetUid: string,
  blocks: Block[],
): string | null {
  const startIdx = blocks.findIndex((b) => b.uid === targetUid);
  if (startIdx === -1) return null;

  for (let i = startIdx + 1; i < blocks.length; i++) {
    const b = blocks[i];
    if (b.uid.startsWith("sec-type-")) break;
    if ("title" in b && b.title === title) return b.uid;
  }
  return null;
}
